import React from "react";
import { TableRow } from "./TableRow"



function hasValues(tableInfo) {
  if (tableInfo.values.length) return tableInfo.values.map((row, index) => <TableRow
    {...tableInfo}
    row={row}
    index={index}
  />)
  else return <b>{tableInfo.nofound}</b>

}

export const Table = props =>
  <div className="relative-wrapper">
    <div className="table-scrollable">
      {props.actions ? <table className="table table-striped table-actions-alt">
        <thead>
          <tr>
            {props.headers.map(header => {
              return <th>{header}</th>
            })}
            <th >Actions</th>
          </tr>
        </thead>
        <tbody>
          {hasValues(props)}
        </tbody>
      </table> : <table className="table table-bordered">
        <thead>
          <tr>
            {props.headers.map(header => {
              return <th>{header}</th>
            })}
          </tr>
        </thead>
        <tbody>
          {hasValues(props)}
        </tbody>
      </table>}
    </div>
  </div >
